import { computed, onMounted } from "vue";
import { storeToRefs } from "pinia";

import { useAccountsStore } from "@stores/accounts";
import { createFilters } from "@/utils/composables/filters/createFilters";

export const useAccountsFilters = () => {
  const accountsStore = useAccountsStore();

  const { clearFilters } = accountsStore;
  const { typeFilter, ownersFilter, owners } = storeToRefs(accountsStore);

  const ownerOptions = computed(() => owners.value.map(({ full_name, id }) => ({ label: full_name, value: id })));

  onMounted(() => {
    if (!owners.value.length) accountsStore.fetchOwners();
  });

  return createFilters({
    filters: [
      {
        id: "type",
        label: "Type",
        options: [
          { label: "Freemium", value: "freemium" },
          { label: "Standard", value: "standard" },
        ],
        model: typeFilter,
      },
      {
        id: "owners",
        label: "Account owner",
        hasSearch: true,
        options: ownerOptions,
        model: ownersFilter,
      },
    ],
    search: () => accountsStore.fetch(1),
    clear: clearFilters,
  });
};
